import defaultsDeep from 'lodash/defaultsDeep';
import defaultBg2 from './assets/backgrounds/HeroBackground-Option2-01.png';

import ghStudentBg from './assets/partners/github/github_student_bg.png';
import ghStudentLogo from './assets/partners/github/github_student_logo.png';

import { ButtonVariations, VariantProps } from './interfaces/variant';

export const defaultVariant: VariantProps = {
  id: 1,
  type: 'defaultVariant1',
  splash: {
    background: {
      url: defaultBg2,
    },
    title: {
      text: 'Welcome to DigitalOcean!',
      color: 'light',
    },
    subtitle: {
      text: 'Sign up for an account to get started.',
      color: 'light',
    },
  },
  loginTitle: 'Log in to your account',
  loginSubtitle: '',
};

export const teamVariant: VariantProps = defaultsDeep(
  {
    id: 0,
    type: 'teamVariant',
    title: 'Join your team on DigitalOcean!',
    subtitle: '{{name}} has invited you to join them. Sign in and start making waves with your team today!',
  },
  defaultVariant,
);

export const githubLoginVariant: VariantProps = {
  ...defaultVariant,
  id: 0,
  weight: '0',
  type: 'githubStudentPack',
  loginTitle: 'Log into your account',
  loginSubtitle: 'In order to claim your credits please log in to your DigitalOcean account',
  splash: {
    ...defaultVariant.splash,

    background: {
      url: ghStudentBg,
    },
    titleImage: {
      image: {
        url: ghStudentLogo,
      },
      size: 'large',
    },
    title: {
      text: 'GitHub Student Developer Pack',
      color: 'dark',
    },
    subtitle: {
      color: 'dark',
      text: `As a part of GitHub student developer pack, you will receive ${
        '$200' /* eslint-disable-line @do/no-hardcoded-prices */
      } in credit that are valid for 1 year. Once you sign up you will be prompted to verify your GitHub account`,
    },
    cta: {
      variant: ButtonVariations.SECONDARY,
      text: 'Learn more',
      href: 'https://education.github.com/pack?utm_source=github+digitalocean',
    },
  },
};
